<template>
  <div class="text" v-html="html" />
</template>

<script>
import $ from 'jquery'
import VBar from 'v-bar'
export default {
  name: 'Content',

  props: [
    'html'
  ],

  components: {
    VBar
  },

  watch: {
    html (val) {
      this.html = val
      this.$nextTick(function () {
        Drupal.attachBehaviors($(this.$el).get(0), Drupal.settings);
      })
    }
  }
}
</script>

<style lang="scss">

</style>